import { defineMessages } from 'react-intl-next';

export default defineMessages({
	loadingMessage: {
		id: 'paginated-picker.async-select.menu-list.loading-message.loading-message',
		defaultMessage: 'Loading...',
		description: 'The text for when options are being loaded in dropdown',
	},
});
